import React from 'react';
import { Icon } from './Icon.js';
export const IconEnvelopeOpen = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M22 8.5L12 15.5L2 8.5", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M22 21H2V8.5L12 1.5L22 8.5V21Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconEnvelopeOpen.js.map